"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SttContainer = _interopRequireDefault(require("./SttLayout/SttContainer"));
var _SttGrid = _interopRequireDefault(require("./SttLayout/SttGrid"));
var _SttBox = _interopRequireDefault(require("./SttLayout/SttBox"));
var _SttLink = _interopRequireDefault(require("./SttTypography/SttLink"));
var _SttModal = _interopRequireDefault(require("./SttModal"));
var _SttText = _interopRequireDefault(require("./SttTypography/SttText"));
var _SttLabel = _interopRequireDefault(require("./SttTypography/SttLabel"));
var _SttButton = _interopRequireDefault(require("./SttButton/SttButton"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    carimbo: {
      color: '#0A6EB9'
    },
    link: {
      fontSize: '1rem',
      cursor: 'pointer'
    }
  };
});
SttCarimboTempo.propTypes = {
  text: _propTypes["default"].string,
  date: _propTypes["default"].string,
  url: _propTypes["default"].string
};
function SttCarimboTempo(props) {
  var classes = useStyles();
  var text = props.text,
    date = props.date,
    url = props.url;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    openModal = _React$useState2[0],
    setOpenModal = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    openModalError = _React$useState4[0],
    setOpenModalError = _React$useState4[1];
  var _React$useState5 = _react["default"].useState({}),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    carimboVerificado = _React$useState6[0],
    setCarimboVerificado = _React$useState6[1];
  var _React$useState7 = _react["default"].useState(),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    errorMessage = _React$useState8[0],
    setErrorMessage = _React$useState8[1];
  function handleTextClick() {
    var reqStamp = new XMLHttpRequest();
    if (url) {
      try {
        reqStamp.open("GET", url, true);
        reqStamp.responseType = "json";
        reqStamp.onload = function (resposta) {
          if (reqStamp.response.errors && reqStamp.response.errors.length) {
            setErrorMessage(reqStamp.response.errors[0].message);
            setOpenModalError(true);
            return;
          }
          var data = reqStamp.response.data;
          setCarimboVerificado(data);
          setOpenModal(true);
        };
        reqStamp.send();
      } catch (e) {
        var mensagem = 'Ocorreu um erro. Tente novamente mais tarde.';
        setErrorMessage(mensagem);
        setOpenModalError(true);
      }
    } else {
      var _mensagem = 'Não foi possível verificar o carimbo do tempo.';
      setErrorMessage(_mensagem);
      setOpenModalError(true);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_SttBox["default"], null, /*#__PURE__*/_react["default"].createElement(_SttBox["default"], null, /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faStamp,
    size: "3x",
    className: classes.carimbo
  })), /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    item: true,
    sm: 3
  }, /*#__PURE__*/_react["default"].createElement(_SttLabel["default"], null, "Identifica\xE7\xE3o (clique no c\xF3digo para verificar)"), /*#__PURE__*/_react["default"].createElement(_SttLink["default"], {
    className: classes.link,
    onClick: handleTextClick,
    underline: "none"
  }, text)), /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    item: true,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_SttLabel["default"], null, "Data/hora do carimbo"), /*#__PURE__*/_react["default"].createElement(_SttText["default"], null, date)))), /*#__PURE__*/_react["default"].createElement(_SttModal["default"], {
    title: "Verifica\xE7\xE3o do carimbo do tempo emitido",
    open: openModal,
    iconClose: function iconClose() {
      return setOpenModal(false);
    },
    children: /*#__PURE__*/_react["default"].createElement(_SttContainer["default"], null, /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
      item: true,
      sm: 10
    }, /*#__PURE__*/_react["default"].createElement(_SttLabel["default"], null, "Data/hora do carimbo"), /*#__PURE__*/_react["default"].createElement(_SttText["default"], null, carimboVerificado['data'])), /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
      item: true,
      sm: 10
    }, /*#__PURE__*/_react["default"].createElement(_SttLabel["default"], null, "Status do carimbo"), /*#__PURE__*/_react["default"].createElement(_SttText["default"], null, carimboVerificado['statusCarimbo'])), /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
      item: true,
      sm: 10
    }, /*#__PURE__*/_react["default"].createElement(_SttLabel["default"], null, "CN do certificado"), /*#__PURE__*/_react["default"].createElement(_SttText["default"], null, carimboVerificado['certificado'])), /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
      item: true,
      sm: 10
    }, /*#__PURE__*/_react["default"].createElement(_SttLabel["default"], null, "Hash do certificado"), /*#__PURE__*/_react["default"].createElement(_SttText["default"], null, carimboVerificado['hashCertificado'])), /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
      item: true,
      sm: 10
    }, /*#__PURE__*/_react["default"].createElement(_SttLabel["default"], null, "CN do emissor"), /*#__PURE__*/_react["default"].createElement(_SttText["default"], null, carimboVerificado['emissor'])), /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
      item: true,
      sm: 10
    }, /*#__PURE__*/_react["default"].createElement(_SttLabel["default"], null, "Status do processo"), /*#__PURE__*/_react["default"].createElement(_SttText["default"], null, carimboVerificado['statusProcesso'])))),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        return setOpenModal(false);
      }
    }, "Fechar"))
  }), /*#__PURE__*/_react["default"].createElement(_SttModal["default"], {
    title: "Erro",
    open: openModalError,
    iconClose: function iconClose() {
      return setOpenModalError(false);
    },
    children: /*#__PURE__*/_react["default"].createElement(_SttContainer["default"], null, errorMessage),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        return setOpenModalError(false);
      }
    }, "Fechar"))
  }));
}
var _default = SttCarimboTempo;
exports["default"] = _default;